export default "data:image/svg+xml,es-ce.svg"